/* SET STATE */
export const SET_STATE_CUSTOMER = "SET_STATE_CUSTOMER"

/* CUSTOMERS */
export const GET_CUSTOMERS = "GET_CUSTOMERS"
export const GET_CUSTOMERS_SUCCESS = "GET_CUSTOMERS_SUCCESS"
export const GET_CUSTOMERS_FAIL = "GET_CUSTOMERS_FAIL"

/* CUSTOMER */
export const GET_CUSTOMER = "GET_CUSTOMER"
export const GET_CUSTOMER_SUCCESS = "GET_CUSTOMER_SUCCESS"
export const GET_CUSTOMER_FAIL = "GET_CUSTOMER_FAIL"

/**
 * ADD CUSTOMER
 */
 export const ADD_NEW_CUSTOMER = "ADD_NEW_CUSTOMER"
 export const ADD_CUSTOMER_SUCCESS = "ADD_CUSTOMER_SUCCESS"
 export const ADD_CUSTOMER_FAIL = "ADD_CUSTOMER_FAIL"

 /**
 * UPDATE CUSTOMER
 */
export const UPDATE_CUSTOMER = "UPDATE_CUSTOMER"
export const UPDATE_CUSTOMER_STATUS = "UPDATE_CUSTOMER_STATUS"
export const UPDATE_CUSTOMER_SUCCESS = "UPDATE_CUSTOMER_SUCCESS"
export const UPDATE_CUSTOMER_FAIL = "UPDATE_CUSTOMER_FAIL"

/**
 * DELETE CUSTOMER
 */
export const DELETE_CUSTOMER = "DELETE_CUSTOMER"
export const DELETE_CUSTOMER_SUCCESS = "DELETE_CUSTOMER_SUCCESS"
export const DELETE_CUSTOMER_FAIL = "DELETE_CUSTOMER_FAIL"
